export const formMachineryManagementNaming = {
  NEW_AUX_MACHINERY_MANAGEMENT_FORM: 'new-machinery-management-form',
};
